<template>
    <div id="rwa_bottom_page" :class="bottomPageClass">
        <div class="rwa_bottom_all">
            <div class="rwa_bottom_01">
              <a href="https://t.me/rwaartinc" target="_blank"><img src="../assets/images/Tele.png"/></a>
              <a href="https://x.com/rwaartinc" target="_blank"><img src="../assets/images/Twitter.png"/></a>
            </div>
            <div class="rwa_bottom_02">
<!--              <div>{{ lang('wkuang') }}</div>-->
<!--              <div>{{ lang('ystxz') }}</div>-->
<!--              <div>{{ lang('dbjj') }}</div>-->
              <div></div>
              <div></div>
              <div></div>
            </div>
            <div class="rwa_bottom_03">
              {{ lang('bqsy') }}
            </div>
        </div>
    </div>
</template>

<script>
import { lang } from "@/tools";
import transfer from "@/tools/transfer";

export default {
  name: "Button",
  components: {},
  data() {
    return {
      bottomPageClass: 'rwa_bottom_page'
    };
  },
  watch: {},
  created() {
    transfer.$on("initBottomClass", () => {
      this.initBottomClass();
    });
  },
  mounted() {
    this.initBottomClass();
  },
  destroyed() {},
  methods: {
    lang(key){
      return lang(key);
    },
    initBottomClass() {
      if (sessionStorage.getItem('menuIndex')) {
        if (sessionStorage.getItem('menuIndex') === '1') {
          this.bottomPageClass = 'rwa_bottom_page';
        } else if (sessionStorage.getItem('menuIndex') === '2') {
          this.bottomPageClass = 'rwa_bottom_page';
        } else if (sessionStorage.getItem('menuIndex') === '3') {
          this.bottomPageClass = 'rwa_bottom_page';
        } else if (sessionStorage.getItem('menuIndex') === '4') {
          this.bottomPageClass = 'rwa_bottom_page';
        } else if (sessionStorage.getItem('menuIndex') === '5') {
          this.bottomPageClass = 'rwa_bottom_page rwa_bottom_page_a';
        } else if (sessionStorage.getItem('menuIndex') === '6') {
          this.bottomPageClass = 'rwa_bottom_page rwa_bottom_page_a';
        } else {
          this.bottomPageClass = 'rwa_bottom_page';
        }
      } else {
        this.bottomPageClass = 'rwa_bottom_page';
      }
    }
  },
};
</script>

<style lang="less">
.rwa_bottom_page_a {
  position: fixed !important;
}
.rwa_bottom_page {
  width: 100%;
  height: 200px;
  background: #001601;
  display: flex;
  padding: 35px 0 30px 0;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 71.365px;
  z-index: 1;
  .rwa_bottom_all {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    height: 100px;
    width: 80%;
    flex-wrap: nowrap;
    .rwa_bottom_01 {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: center;
      align-items: center;
      a {
        cursor: pointer;
        img {
          width: 30px;
          margin: 30px 15px -30px 15px;
        }
      }
    }
    .rwa_bottom_02 {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: center;
      align-items: center;
      margin: 15px 0;
      div {
        cursor: pointer;
        margin: 0 16px;
        opacity: 1;
        color: white;
      }
      div:hover {
        opacity: 0.6;
      }
    }
    .rwa_bottom_03 {
      height: 42px;
      cursor: default;
      font-size: 12px;
      line-height: 42px;
      color: rgba(250, 250, 250, 0.60);
      font-family: Montserrat;
      font-style: normal;
      font-weight: 400;
      opacity: 0.8;
    }
  }
}
</style>
